'use strict';

/* global L */

const _ = require('lodash');
const mapConfig = _.cloneDeep(require('./PreviewMapConfig.js'));

/** @SiteSelectorStore */
function SiteSelectorStore (ResourceHelper, Flux, SiteSelectorActions, APP_DISPATCHER_ID, Utils) {

  const SiteStore = Flux.Store.get('SiteStore');

  //Store init
  const SiteSelectorStore = Flux.Store.create({
    name: 'SiteSelectorStore',
    events: {
      Changed: true,
      SiteSelected: true
    }
  });

  //Null initial state
  SiteSelectorStore.$state = {
    dialogVisibility: false,
    currentSitePreviewMap: null,
    availableSites: [],
    selectedSiteId: null
  };

  /**
   * Constructor function that binds to the interaction Flux.Action Signal from the component
   */
  SiteSelectorStore.init = () => {

    const dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);

    dispatcher.register(SiteSelectorActions.SitePreviewSelected, this._handleSitePreviewSelected.bind(this));
    dispatcher.register(SiteSelectorActions.SiteSelected, this._handleSiteSelected.bind(this));
    dispatcher.register(SiteSelectorActions.ShowSiteSelector, this._handleShowSiteSelector.bind(this));
    dispatcher.register(SiteSelectorActions.HideSiteSelector, this._handleHideSiteSelector.bind(this));
  };

  // Handlers //////////////////////////////////////////////////////////////////
  /**
   * Creates the available sites list and adds the project name for them
   */
  this._handleStoreChange = () => {
    const availableSites = SiteStore.get('available');

    if (availableSites && availableSites.length) {
      // name projects for each site
      // `availableSites` contains only site-like objects, see [CORE-845]
      SiteSelectorStore.$set('availableSites', _.map(availableSites, (site) => {
        return {
          id: site.id,
          name: site.name,
          slug: site.slug,
          projectId: site.projectId,
          projectName: site.projectName,
          location: typeof site.location === 'string' ? JSON.parse(site.location) : site.location
        };
      }));

      // autoselect current site for list
      if (SiteStore.get('current')) {
        SiteSelectorActions.SitePreviewSelected.dispatch({
          site: SiteStore.get('current')
        });
      }
    }
  };

  /**
   * When a preview is selected in the list, upadtes the site list and adds the selected flag to the one on the ev.data
   * @param {object} [event] and event object containing the selected site on the list
   */
  this._handleSitePreviewSelected = (ev) => {
    //no sites data yet? do nothing
    if (!ev.data.site && SiteSelectorStore.$state.availableSites.length < 1){
      return;
    }

    ResourceHelper.getResource('Site')
    .getDefaultDataCapture(ev.data.site.id)
    .then((defaultDataCapture) => {
      const selectedSiteId = SiteSelectorStore.get('selectedSiteId');

      if (selectedSiteId) { // It was previously set
        if (selectedSiteId === ev.data.site.id) {
          // Site already selected. Do nothing
          return;
        }
        SiteSelectorStore.$set('selectedSiteId', ev.data.site.id);
      }
      else {
        if (ev.data.site.id) {
          // Blank state
          SiteSelectorStore.$set('selectedSiteId', ev.data.site.id);
        }
        else {
          // It is first load. Filter booster will default to the first one,
          // so set it to the current site instead
          const currentSiteId = SiteStore.get('current').id;
          SiteSelectorStore.$set('selectedSiteId', currentSiteId);
        }
      }

      SiteSelectorStore.$set('currentSitePreviewMap', this.cookSitePreviewMap(ev.data.site, defaultDataCapture));
      SiteSelectorStore.emit(SiteSelectorStore.Events.Changed);
    });
  };

  this._handleSiteSelected = () => {
    SiteSelectorStore.emit(SiteSelectorStore.Events.SiteSelected);
  };

  this._handleShowSiteSelector = () => {

    const visibility = SiteSelectorStore.get('dialogVisibility');

    if (visibility === false) {
      SiteSelectorStore.$set('dialogVisibility', !visibility);
      SiteSelectorStore.emit(SiteSelectorStore.Events.Changed);
    }
  };

  this._handleHideSiteSelector = () => {

    const visibility = SiteSelectorStore.get('dialogVisibility');

    if (visibility === true) {
      SiteSelectorStore.$set('dialogVisibility', !visibility);
      SiteSelectorStore.emit(SiteSelectorStore.Events.Changed);
    }
  };

  /**
   * Utility function to create a booster compatible site data
   */
  this.cookSitePreviewMap = (site, defaultDataCapture) => {
    let datacaptures;

    let location = _.clone(site.location);

    if (typeof location === 'string') {
      location = JSON.parse(location);
    }

    mapConfig.mapCenter = _.pick(location, ['lat', 'lng', 'zoom']);
    const mapUtil = Utils.Map.create(mapConfig);
    location.bounds = L.latLngBounds([location.bounds.bottom, location.bounds.left], [location.bounds.top, location.bounds.right]);

    if (defaultDataCapture) {
      // TODO: Refactor, this is the same format as MapController#datacaptures
      const formattedDataCapture = _.cloneDeep(defaultDataCapture);
      formattedDataCapture.layers = _.cloneDeep(formattedDataCapture.dataCaptureLayers).filter((layer) => {
        layer.dataCaptureId = formattedDataCapture.id;
        layer.layerId = layer.layerData;

        return layer.layerType === 'tileLayer';
      });

      datacaptures = [formattedDataCapture];
    }

    return {
      id: site.id,
      slug: site.slug,
      center: mapConfig.mapCenter,
      defaults: mapUtil.getMapDefaults(),
      events: mapConfig.events,
      datacaptures
    };
  };

  //Bindings
  SiteStore.on(SiteStore.Events.Changed, this._handleStoreChange.bind(this));

  return SiteSelectorStore;
}

SiteSelectorStore.$inject = ['ResourceHelper', 'sbFlux', 'SiteSelectorActions', 'APP_DISPATCHER_ID', 'Utils'];

module.exports = SiteSelectorStore;



// WEBPACK FOOTER //
// ./src/app/dash/siteSelector/SiteSelectorStore.js